export enum PackageStepStatus {

    NotPassed,
    Passed,
}
